import './styles/App.css';
import './styles/gallery.css';
import React from 'react'
import { ethers } from 'ethers';
import { useState , useEffect} from 'react';
import connector from './utils.js'
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
function PresentAdder(props) {
  const [contract, setContract]=useState('undefined');
  const [signer,setSigner] = useState('');
  const [provider,setProvider] = useState('');
  const [accounts,setAccounts] = useState([]);
  useEffect(() => {
    const init = async()=>{
      const lis = await connector(props.address);
      setContract(await lis.contract);
      setProvider(await lis.provider);
      setAccounts(await lis.accounts);
      setSigner(await lis.signer);
    }
    init();  
  },[]);
  
  async function getPresents (){
    var id = await contract.connect(signer).startId();
    var presents = [];
    console.log(Number(id))
    for (var i = 1; i<id;i++){
      var pres = await contract.connect(signer).idToPresent(i);
      console.log(pres);
      presents.push(pres); 
    }
  }
  async function handleSubmit (event) {
    event.preventDefault()
    console.log(event.target.length)
    for (var i =0;i<event.target.length -1;i++){
      console.log(event.target[i].value)
    }
    const ob = ind =>{
      return(event.target[ind].value)
    }
    contract.connect(signer).addPresent(ob(0),ob(1),ob(2),ob(3),ob(4),ob(5),ob(7),ob(6));
  }
  async function onlyNow(){
    var item = [
      "Chocolate Cup",
      "Pretty white ceramic cup. I gifted it to my 13-yr old nephew and he was delighted. Beautiful and sturdy.",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2016/11/Free-Vintage-Images-TeacupRoses-GraphicsFairy1-768x594.jpg",
      "Household",
      13,
      2,
      1000
    ]
    var item2 = [
      "Vintage Cup",
      "A beautiful vintage design cup with flowers and a an accompanying saucer",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2019/04/teacup-scrap-Antique-GraphicsFairy2-768x578.jpg",
      "HouseHold",
      27,
      1,
      650
    ]
    var item3 =[
      "Tea Cup- Blue",
      "A blue ceramic cup in a vintage style. Great for regular tea-drinkers",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2019/04/teacup-scrap-Antique-GraphicsFairy2-768x578.jpg",
      "HouseHold",
      32,
      3,
      490
    ]
    var item3 =[
      "Tea Cup- Blue",
      "Ceramic cup with beautiful design. Perfect for kids.",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2019/04/Tea-Cup-Fancy-Floral-GraphicsFairy-1-768x552.jpg",
      "HouseHold",
      32,
      3,
      490
    ]
    var item4=[
      "Kid's Cup",
      "A blue ceramic cup in a vintage style. Great for regular tea-drinkers",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2019/04/Teacup-Saucer-Colorful-Vintage-Image-GraphicsFairy-1-768x516.jpg",
      "HouseHold",
      10,
      1,
      550
    ]
    var item5=[
      "Flower Vase",
      "Green Glass vase with narrow bottom and broad top",
      "https://thegraphicsfairy.com/floral-vase-images/",
      "https://thegraphicsfairy.com/wp-content/uploads/2020/05/roses-vase-vintage-image-GraphicsFairy-1024x756.jpg",
      "HouseHold",
      40,
      2,
      850
    ]
    var item6= [
      "Printed Cup",
      "Minimalistic design of birds in water color. With Saucer",
      "https://thegraphicsfairy.com/vintage-graphics-3-pretty-teacups-with-roses/",
      "https://thegraphicsfairy.com/wp-content/uploads/2019/04/teacupbirdsvintageimage-graphicsfairy009.jpg",
      "HouseHold",
      20,
      3,
      450
    ]
    var ars = [item6]
    for (var i =0 ;i <ars.length;i++){
      var currAr = ars[i]
      contract.connect(signer).addPresent(currAr[0],currAr[1],currAr[2],currAr[3],currAr[4],currAr[5],currAr[6],currAr[7]);
    }
    
  }
  
  return (
    <div className="App">
      <meta name="viewport" content="initial-scale=1, width=device-width" />
      <nav>
      <div className='linkButton' id ='linkbutton'>
        <Link to ="/" id="homeLink" className='homelink'></Link>   
        <Link to ="/" id="logo"></Link>      

        <Link to="/add" id = "addLink">
          <button id = 'addButt'>ADD PRESENT</button>
        </Link>  
        <Link to="/profile" id = "profLink">
          <button id = 'profButt'>PROFILE</button>
        </Link>  
      </div>
    </nav>
      <form onSubmit={handleSubmit}>
        <input type="text" placeholder='Name' id = "name" ></input>
        <input type="text" placeholder='Description' id = "desc"></input>
        <input type="text" placeholder='Link' id = "link"></input>
        <input type="text" placeholder='Photo' id = "photo"></input>
        <input type="text" placeholder='Category' id = "categ"></input>
        <input type="number" placeholder='Age' id = "age"></input>
        <input type="number" placeholder='Price' id = "price"></input>
        <select id="gender">
          <option className='opt' value="1"selected>
            <span>&#9792; :  Female  </span>
          </option>
          <option className='opt' value="2">
            <span>&#9794; :  Male  </span>
          </option>
          <option className='opt' value="3" > 
            <span>&#9893; : Other  </span>
          </option>
        </select>
        <Button variant="contained" color="primary" type="submit">Submit</Button>
      </form>
      
    </div>
  );
}

export default PresentAdder;
